<template>
  <pu-modal
    class="login-modal"
    :class="{ desktop: $isDesktop }"
    :modal-hash="modalHash"
  >
    <template #modal-trigger>
      <slot />
    </template>
    <template #default="{ closeModal }">
      <header>
        <img src="~/assets/images/pitchup-favicon.svg" />
      </header>
      <login-form
        :email="email"
        :use-modal-portal="useModalPortal"
        @loginSuccess="handleLoginSuccess(closeModal)"
      />
    </template>
  </pu-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class LoginModal extends Vue {
  @Prop()
  email: string

  @Prop({ default: 'login-form' })
  modalHash: string

  @Prop({ default: true })
  useModalPortal: boolean

  handleLoginSuccess(closeModal: () => void) {
    closeModal()
    this.$emit('loginSuccess')
  }
}

export default toNative(LoginModal)
</script>
<style scoped>
.login-modal :deep(.modal-body header) {
  padding: 1em 0 0 1.4em !important;
}

header img {
  height: 2em;
  width: auto;
}

.login-modal :deep(.modal-container) {
  min-height: calc(100% - 6vw);
}

/* desktop & tablet */
.login-modal.desktop :deep(.modal-container) {
  min-height: max-content;
}
</style>
